module.exports = __webpack_public_path__ + "img/article_ad_banner_04.d71f486b.jpg";